<<template>
  <article>
    <section class="xbed-sub-title">
      <span>关联管理</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>渠道列表</BreadcrumbItem>
        <BreadcrumbItem>关联管理：{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="渠道门店" name="hotelList" ref="hotelList">
        <Form @submit.native.prevent="preventSubmit" :model="hotelList.form" inline>
          <FormItem prop="matchStatus" label="筛选匹配状态：" :label-width="110">
            <Select v-model="hotelList.form.matchStatus" filterable transfer>
              <Option value="S00">全部</Option>
            </Select>
          </FormItem>
          <FormItem prop="hotel" label="xbed门店：" :label-width="94">
            <Input type="text" v-model="hotelList.form.hotel" placeholder="请输入搜索关键字"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary">查询</Button>
          </FormItem>
          <FormItem>
            <Button type="primary">更新匹配状态</Button>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="openAddHotelModal">新增门店匹配</Button>
          </FormItem>
        </Form>
        <Table stripe class="tableList" :loading="hotelList.loading" height="450" :columns="hotelList.columns" :data="hotelList.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :total="hotelList.count" :current="hotelList.page" :page-size="hotelList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </TabPane>
      <TabPane label="渠道房型" name="roomTypeList" ref="roomTypeList">
        <Form @submit.native.prevent="preventSubmit" :model="roomTypeList.form" inline>
          <FormItem prop="dockingStatus" label="打包状态：" :label-width="90">
            <Select v-model="roomTypeList.form.dockingStatus" filterable>
              <Option value="S00">全部</Option>
            </Select>
          </FormItem>
          <FormItem prop="matchStatus" label="匹配状态：" :label-width="90">
            <Select v-model="roomTypeList.form.matchStatus" filterable>
              <Option value="S00">全部</Option>
            </Select>
          </FormItem>
          <FormItem prop="hotelName" label="所属门店：" :label-width="90">
            <Input type="text" v-model="roomTypeList.form.hotelName" placeholder="查询关键字"></Input>
          </FormItem>
          <FormItem prop="roomTypeName" label="查询：" :label-width="60">
            <Input type="text" v-model="roomTypeList.form.roomTypeName" placeholder="查询关键字"></Input>
          </FormItem>
          <FormItem prop="roomTypeQuery">
            <Button type="primary">查询</Button>
          </FormItem>
        </Form>
        <Table stripe :loading="roomTypeList.loading" height="450" :columns="roomTypeList.columns" :data="roomTypeList.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :total="roomTypeList.count" :current="roomTypeList.page" :page-size="roomTypeList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </TabPane>
    </Tabs>

    <Modal v-model="addHotelModal.display" ref="addHotelModal" :loading="true" :width="1000" title="xbed门店列表" @on-ok="prepareAddHotel" ok-text="提交匹配申请" cancel-text="关闭">
      <Form @submit.native.prevent="preventSubmit" v-model="addHotelModal.form" inline>
        <FormItem  label="省市：" prop="city" :label-width="60">
          <Cascader v-model="addHotelModal.form.city" :data="provCityList" :load-data="queryHotelCities" :transfer="true"></Cascader>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="queryHotelListWithUnbind">查询</Button>
        </FormItem>
        <FormItem v-if="addHotelModal.data.length>0" style="float: right;" label="查询：" prop="keyword" :label-width="60">
          <Input type="text" v-model="addHotelModal.form.keyword"  @on-enter="queryXbedHotelListWithKeyword" @on-change="queryXbedHotelListWithKeyword" placeholder="查询关键字"></Input>
        </FormItem>
      </Form>
      <Table stripe highlight-row :loading="addHotelModal.loading" :columns="addHotelModal.columns" :data="addHotelModal.displayData" @on-current-change="changeSelectedHotel"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page placement="top" :total="addHotelModal.count" :current="addHotelModal.page" @on-change="changeModalPage"></Page>
      </div>
      <br/>
      <Form v-if="addHotelModal.selectedHotel.chainId" ref="addHotelModalForm" :rules="addHotelModal.rules" :model="addHotelModal.selectedHotel" :label-width="150">
        <FormItem label="已选门店ID" prop="title">
          <span>{{addHotelModal.selectedHotel.chainId || ""}}</span>
        </FormItem>
        <FormItem label="已选门店名称">
          <span>{{addHotelModal.selectedHotel.chainName || ""}}</span>
        </FormItem>
        <FormItem label="途家门店名称" prop="tujiaName">
          <Input style="width:350px" v-model="addHotelModal.selectedHotel.tujiaName"></Input>
        </FormItem>
        <FormItem label="省份">
          <span>{{addHotelModal.selectedHotel.province || ""}}</span>
        </FormItem>
        <FormItem label="城市">
          <span>{{addHotelModal.selectedHotel.city || ""}}</span>
        </FormItem>
        <FormItem label="区域">
          <span>{{addHotelModal.selectedHotel.district || ""}}</span>
        </FormItem>
        <FormItem label="联系电话" prop="contactPhone">
          <Input type="text" v-model="addHotelModal.selectedHotel.contactPhone"></Input>
        </FormItem>
        <FormItem label="联系邮件" prop="email">
          <Input type="email" v-model="addHotelModal.selectedHotel.email"></Input>
        </FormItem>
        <FormItem label="地址" prop="address">
          <Input type="text" v-model="addHotelModal.selectedHotel.address"></Input>
        </FormItem>
        <FormItem label="经度" prop="longitude">
          <Input type="text" v-model="addHotelModal.selectedHotel.longitude"></Input>
        </FormItem>
        <FormItem label="纬度" prop="latitude">
          <Input type="text" v-model="addHotelModal.selectedHotel.latitude"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="addHotelModal.selectedHotel.remark"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";
import {emailRegular, contactPhoneRegExp, LngAndLatRegExp} from "@/utils/regular"
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryHotelProvinces();
    this.toggleTab(this.currTabName);
  },
  data() {
    return {
      channelId: 4,
      title: "门店列表",
      currBundleName: "hotel",
      currTabName: "hotelList",
      provCityList: [],
      hotelList: {
        tabName: "hotelList",
        title: "门店列表",
        form: {
          matchStatus: "S00",
          hotel: "",
          keyword: ""
        },
        count: 0, //记录总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: [],
        columns: [
          {
            title: "渠道门店ID",
            key: "id",
            align: "center",
            width: 120,
            fixed: "left"
          },
          {
            title: "渠道门店名称",
            key: "xbedHotelName",
            align: "center",
            width: 300
          },
          {
            title: "省份",
            key: "provCityDist",
            align: "center",
            width: 300
          },
          {
            title: "城市",
            key: "provCityDist",
            align: "center",
            width: 300
          },
          {
            title: "地址",
            key: "address",
            align: "center",
            width: 350
          },
          {
            title: "xbed门店",
            key: "xbedHotelName",
            align: "center",
            width: 300
          },
          // {
          //   title: "所属热点",
          //   key: "hotspot",
          //   align: "center",
          //   width: 200
          // },
          {
            title: "匹配状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let status = params.row.status == "S01" ? "上线" : "下线";
              return h("div", {}, status);
            }
          },
          {
            title: "在线状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let status = params.row.status == "S01" ? "上线" : "下线";
              return h("div", {}, status);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        if (this.$router) {
                          this.$router.push({
                            path: "/app/Ota/Ota/tujia/channelHotelDetail",
                            query: { hotelId: params.row.channelHotelId }
                          });
                        } else {
                          window.open(
                            `#/Ota/Ota/xbedChannelHotelDetail?hotelId=${
                              params.row.channelHotelId
                            }`
                          );
                        }
                      }
                    }
                  },
                  "查看详情"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        console.info(params);
                      }
                    }
                  },
                  "房价房态"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {}
                    }
                  },
                  "重新匹配"
                )
              ]);
            }
          }
        ]
      },
      roomTypeList: {
        tabName: "roomTypeList",
        title: "房型列表",
        form: {
          hotel: "",
          matchStatus: "S00",
          dockingStatus: "S00"
        },
        count: 0, //记录总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: [],
        columns: [
          {
            title: "房型id",
            key: "xbedRoomTypeId",
            align: "center",
            width: 100,
            fixed: "left"
          },
          {
            title: "销售状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let status = "";
              switch (params.row.status) {
                case "S01":
                  status = "上架";
                  break;
                case "S02":
                  status = "下架";
                  break;
              }
              return h("div", {}, status);
            }
          },
          {
            title: "房型名称",
            key: "xbedRoomTypeName",
            align: "center",
            width: 300
          },
          {
            title: "城市",
            key: "city",
            align: "center",
            width: 300
          },
          {
            title: "所属门店",
            key: "xbedHotelName",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h(
                "div",
                {},
                `${params.row.xbedHotelId}_${params.row.xbedHotelName}`
              );
            }
          },
          {
            title: "取价房",
            key: "priceRoomName",
            align: "center",
            width: 250,
            render: (h, params) => {
              let priceRoomId = params.row.priceRoomId
                ? params.row.priceRoomId
                : "";
              let priceRoomName = params.row.priceRoomName
                ? params.row.priceRoomName
                : "";
              let name =
                priceRoomId && priceRoomName
                  ? `${priceRoomId}_${priceRoomName}`
                  : "";
              return h("div", {}, name);
            }
          },
          {
            title: "打包房量",
            key: "dockingCount",
            align: "center",
            width: 200,
            render: (h, params) => {
              let count = params.row.dockingCount ? params.row.dockingCount : 0;
              return h("div", {}, count);
            }
          },
          {
            title: "缓冲房量",
            key: "bufferCount",
            align: "center",
            width: 200,
            render: (h, params) => {
              let count = params.row.bufferCount ? params.row.bufferCount : 0;
              return h("div", {}, count);
            }
          },
          {
            title: "匹配状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let status = params.row.status == "S01" ? "上线" : "下线";
              return h("div", {}, status);
            }
          },
          {
            title: "在线状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let status = params.row.status == "S01" ? "上线" : "下线";
              return h("div", {}, status);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        if (this.$router) {
                          this.$router.push({
                            path: "/app/Ota/Ota/tujia/channelRoomTypeDetail",
                            query: { roomTypeId: params.row.xbedRoomTypeId }
                          });
                        } else {
                          window.open(
                            `#/Ota/Ota/xbedChannelRoomTypeDetail?roomTypeId=${
                              params.row.xbedRoomTypeId
                            }`
                          );
                        }
                      }
                    }
                  },
                  "编辑打包"
                )
              ]);
            }
          }
        ]
      },
      addHotelModal: {
        display: false,
        columns: [
          {
            title: "xbed门店id",
            key: "chainId",
            align: "center",
            width: 120,
            fixed: "left"
          },
          {
            title: "xbed门店名称",
            key: "chainName",
            align: "center",
            width: 200
          },
          {
            title: "省份",
            key: "province",
            align: "center",
            width: 100
          },
          {
            title: "城市",
            key: "city",
            align: "center",
            width: 200
          },
          // {
          //   title: "热点名称",
          //   key: "hotspotName",
          //   align: "center",
          //   width: 250
          // },
          {
            title: "类型",
            key: "type",
            align: "center",
            width: 200,
            render: (h, params) => {
              let status = params.row.chainType == 0 ? "分散" : "聚集";
              return h("div", {}, status);
            }
          }
        ],
        form: {
          city: [],
          keyword: ""
        },
        name: "hotel",
        tabName: "门店列表",
        count: 0, //记录总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: [],
        filterDataList: [],
        displayData: [],
        selectedHotel: {
          chainId: '',
          chainName: '',
          tujiaName: '',
          province: '',
          city: '',
          district: '',
          contactPhone: '',
          email: '',
          address: '',
          longitude: '',
          latitude: '',
          remark: ''
        },
        rules: {
          contactPhone: [
            { required: true, message: "联系电话不能为空", trigger: "blur" },
            { type: "string", pattern: contactPhoneRegExp, message: "请填写正确的联系电话" }
          ],
          tujiaName: [
            { required: true, message: "途家门店名称不能为空", trigger: "blur" }
          ],
          email: [
            { required: true, message: "联系邮箱不能为空", trigger: "blur" },
            { type: "string", pattern: emailRegular, message: "请填写正确的联系邮箱" }
          ],
          address: [
            { required: true, message: "地址不能为空", trigger: "blur" }
          ],
          longitude: [
            { required: true, message: "经度不能为空", trigger: "blur" },
            { type: "string", pattern: LngAndLatRegExp, message: "请填写正确的经度" }
          ],
          latitude: [
            { required: true, message: "纬度不能为空", trigger: "blur" },
            { type: "string", pattern: LngAndLatRegExp, message: "请填写正确的纬度" }
          ],
          remark: [
            { required: false, type: 'string', max: 255,  message: "备注不能超过255字", trigger: "blur" }
          ]
        }
      }
    };
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.title = this[tabName].title;
      this[tabName].page = 1;
      this.queryOtaList();
    },
    changePage(pageIndex) {
      this[this.currTabName].page = pageIndex;
      this.queryOtaList();
    },
    changePageSize(pageSize) {
      this[this.currTabName].page = 1;
      this[this.currTabName].pageSize = pageSize;
      this.queryOtaList();
    },
    changeModalPage(pageIndex) {
      this.addHotelModal.page = pageIndex;
      this.queryHotelListWithUnbind();
    },
    openAddHotelModal() {
      this.resetAddHotelModal();
      this.addHotelModal.display = true;
    },
    async queryHotelProvinces() {
      let resp = (await API.omsAPI[this.env].ota.queryHotelProvinces(
        this.channelId,
        this.token
      )).data;
      if (resp.status == false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.forEach(prov => {
        prov.label = prov.province;
        prov.value = prov.province;
        prov.loading = false;
        prov.children = [];
      });
      this.provCityList = resp;
    },
    async queryHotelCities(item, callback) {
      item.loading = true;
      let resp = (await API.omsAPI[this.env].ota.queryHotelCities(
        this.channelId,
        item.value,
        this.token
      )).data;
      if (resp.status == false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.forEach(city => {
        city.label = city.city;
        city.value = city.city;
      });
      item.children = resp;
      item.loading = false;
      callback();
    },
    queryWithKeyword() {
      this[this.currTabName].page = 1;
      this[this.currTabName].pageSize = 10;
      this.queryOtaList();
    },
    async queryOtaList() {
      if (this.currTabName == "hotelList") {
        this.queryHotelList();
      } else if (this.currTabName == "roomTypeList") {
        this.queryAllRoomTypeList();
      }
    },
    async queryHotelList() {
      this.hotelList.loading = true;
      let resp = (await this.sendQueryHotelList(
        this.hotelList,
        this.token,
        this.env
      )).data;
      if (resp.status == false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.result.forEach(hotel => {
        hotel.provCityDist = `${hotel.province ? hotel.province : ""}${
          hotel.city ? hotel.city : ""
        }${hotel.district ? hotel.district : ""}`;
      });
      this.hotelList.data = resp.result;
      this.hotelList.page = resp.page;
      this.hotelList.count = resp.count;
      this.hotelList.loading = false;
    },
    // TODO:mock数据
    sendQueryHotelList(hotelList, token, env) {
      let hotelId = hotelList.form.hotel.length == 0 ? 0 : hotelList.form.hotel;
      return API.omsAPI[env].ota.queryHotelList(
        this.channelId,
        "",
        hotelList.page,
        hotelList.pageSize,
        hotelId,
        "",
        token
      );
    },
    async queryAllRoomTypeList() {
      this.roomTypeList.loading = true;
      let resp = (await this.sendQueryAllRoomTypeList(
        this.roomTypeList,
        this.token,
        this.env
      )).data;
      if (resp.status == false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      this.roomTypeList.data = resp.list;
      this.roomTypeList.page = resp.page;
      this.roomTypeList.count = resp.rowCount;
      this.roomTypeList.loading = false;
    },
    // TODO:mock
    sendQueryAllRoomTypeList(roomTypeList, token, env) {
      let dockingStatus =
        roomTypeList.form.dockingStatus == "S00"
          ? ""
          : roomTypeList.form.dockingStatus;
      return API.omsAPI[env].ota.queryAllRoomTypeList(
        this.channelId,
        dockingStatus,
        roomTypeList.form.hotel,
        "",
        roomTypeList.page,
        roomTypeList.pageSize,
        token
      );
    },
    // 删除门店
    async delHotel(index) {
      let hotel = this.hotelList.data[index];

      let resp = (await API.omsAPI[this.env].ota.removeHotel(
        hotel.xbedHotelId,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除门店失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除门店成功"
        });

        this.hotelList.data.splice(index, 1);
      }
    },
    // 删除房型
    async removeRoomType(index) {
      let roomType = this.roomTypeList.data[index];

      let resp = (await API.omsAPI[this.env].ota.removeRoomType(
        this.channelId,
        this.username,
        roomType.xbedRoomTypeId,
        roomType.xbedHotelId,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除房型失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除房型成功"
        });

        this.roomTypeList.data.splice(index, 1);
      }
    },
    async queryHotelListWithUnbind() {
      if (this.addHotelModal.form.city.length == 0) {
        this.$Notice.error({
          title: "查询门店失败",
          desc: "请选择省市"
        });
        return;
      }
      this.addHotelModal.loading = true;
      let resp = (await this.queryXbedHotelList(
        this.token,
        this.env
      )).data;
      if (resp.status == false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.forEach(hotel => {
        hotel.chainType = hotel.chainType == 0 ? "分散" : "聚集";
      });
      this.addHotelModal.data = resp;
      this.addHotelModal.count = resp.length;
      this.addHotelModal.filterDataList = this.addHotelModal.data;
      this.displayXbedHotelList();
      this.addHotelModal.loading = false;
    },
    queryXbedHotelList(token, env) {
      return API.omsAPI[env].ota.queryHotelListWithUnbind(
        this.channelId,
        this.addHotelModal.form.city[1],
        this.addHotelModal.form.city[0],
        token
      );
    },
    displayXbedHotelList() {
      let startIndex = (this.addHotelModal.page - 1) * this.addHotelModal.pageSize;
      let endIndex = this.addHotelModal.pageSize * this.addHotelModal.page;
      this.addHotelModal.displayData = [];

      let filterDataList = [];
      for (let i = startIndex; i < endIndex; i++) {
        if (!this.addHotelModal.filterDataList[i]) break;
        filterDataList.push(this.addHotelModal.filterDataList[i]);
      }
      this.addHotelModal.displayData = filterDataList;

    },
    queryXbedHotelListWithKeyword() {
      this.addHotelModal.loading = true;
      this.addHotelModal.filterDataList = this.filterXbedHotelListWithKeyword();
      this.addHotelModal.page = 1;
      this.addHotelModal.count = this.addHotelModal.filterDataList.length;
      this.displayXbedHotelList();
      this.addHotelModal.loading = false;
    },
    filterXbedHotelListWithKeyword() {
      let self = this;
      return this.addHotelModal.data.filter(function(hotel) {
        let result = false;
        for (let itemKey in hotel) {
          if (self.skipKeyFromData(itemKey)) {
            continue;
          }
          let queryItem = "" + hotel[itemKey];
          if (
            queryItem
              .toUpperCase()
              .indexOf(self.addHotelModal.form.keyword.toUpperCase()) !== -1
          ) {
            result = true;
            break;
          }
        }
        return result;
      });
    },
    skipKeyFromData(key) {
      let isSkip = false;
      switch (key) {
        case "address":
        case "contactName":
        case "contactPhone":
        case "remind":
        case "hotspotId":
          isSkip = true;
          break;
      }
      return isSkip;
    },
    changeSelectedHotel(currHotel) {
      this.addHotelModal.selectedHotel = Object.assign({}, this.addHotelModal.selectedHotel, {
        chainId: currHotel.chainId,
        chainName: currHotel.chainName,
        province: currHotel.province,
        city: currHotel.city,
        district: currHotel.district
      });
    },
    async prepareAddHotel() {
      let validResult = false;
      this.$refs.addHotelModalForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      }

      let resp = (await API.omsAPI[this.env].ota.addHotel(
        this.addHotelModal.selectedHotel.chainId,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        // 错误警告
        this.$refs.addHotelModal.buttonLoading = false;
        this.$Notice.error({
          title: "添加门店失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "添加门店成功"
        });
        this.addHotelModal.display = false;
        this.refreshTable();
      }
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
    resetTabPane() {
      this.hotelList = {
        tabName: "hotelList",
        title: "门店列表",
        count: 0, //记录总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      };
      this.roomTypeList = {
        tabName: "roomTypeList",
        title: "房型列表",
        count: 0, //记录总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      };
    },
    resetAddHotelModal() {
      this.addHotelModal = Object.assign({}, this.addHotelModal, {
        count: 0, //记录总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: [],
        displayData: [],
        form: {
          city: [],
          keyword: ""
        },
        selectedHotel: {}
      })
    },
    refreshTable() {
      this.resetTabPane();
      this.hotelList.form = {
        matchStatus: "S00",
        hotel: "",
        keyword: ""
      };
      this.roomTypeList.form = {
        hotelName: "",
        matchStatus: "S00",
        dockingStatus: "S00"
      };
      this.queryHotelProvinces();
      this[this.currTabName].page = 1;
      this.queryOtaList();
    }
  }
};
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ota/tujia/list.vue